import type { ListQuery } from './api/client';

/**
 * 목록 → 상세로 넘기는 router state (컨셉 §7.5).
 *
 * - ids  : 검색 결과 · 사진 검색 · 비슷한 원단 — 그 결과 순서로 PREV / NEXT.
 * - list : 홈 「최근 등록」 · 전체 원단 — 같은 정렬 · 필터를 서버 neighbors 로 (목록 전체 기준).
 * - from : 「검색 결과로 / 사진 검색으로 / 목록으로」 가 돌아갈 주소(쿼리 · 페이지 포함).
 * - why  : 누른 카드의 추천 사유(검색 결과) — 카드는 사진 중심이라 사유를 마우스 올림 · 목록 보기에서만 보이므로,
 *          휴대폰에서도 상세 머리에서 읽게 넘긴다(컨셉 §7.7 「휴대폰에선 상세에서」). 그 원단일 때만 쓴다.
 */
export interface DetailState {
  ids?: string[];
  list?: ListQuery & { size?: number };
  from?: string;
  why?: { id: string; text: string };
}

export function readDetailState(s: unknown): DetailState {
  return (s && typeof s === 'object' ? s : {}) as DetailState;
}
